import { useState } from 'react';
import '../QuizType2/QuizType2.scss';
import Column from '../QuizType2/Column/Column';
import ColumnSource from './ColumnSource/ColumnSource';
import QuestionCount from '../QuestionCount/QuestionCount';
import { DragDropContext } from '@hello-pangea/dnd';

import { setNewStateForQuizType4 } from '../quizSlice';




const QuizType4 = (props) => {
  
 //const [stateDataStatus, setStateDataStatus] = useState(false);
 
 //const [stateAnswertatus3Version, setStateAnswerStatus3Version] = useState(false);
 //const [stateDataStatusResult, setStateDataStatusResult] = useState(false);
 
 //const [stateDataStatus3VersionResult, setStateDataStatus3VersionResult] = useState(false);
  
  //const initialData = props.quizRedux.initialDataForQuizType2;
 
  // FIND DATA  BY QUESTION ID
const questionId = props.quizRedux.questionIdForDB;

const  findQuestionById = (questionId) => {
  console.log(questionId);
    const data = props.quizRedux.initialDataForQuizType4;
    console.log(data);
    const index = data.findIndex(item => item.id === Number(questionId));
    

  console.log(index);
  return index;
};
const indexOfQuestion = findQuestionById(questionId);
console.log(indexOfQuestion);

//SET DATA BY QUESTION ID
 // const initialData = props.quizRedux.initialDataForQuizType4[indexOfQuestion];
//console.log(initialData);

const  findQuestionByIdSource = (questionId) => {
  console.log(questionId);
    const data = props.quizRedux.initialDataForQuizType4Source;
    console.log(data);
    const index = data.findIndex(item => item.id === Number(questionId));
    

  console.log(index);
  return index;
};
const indexOfQuestionSource = findQuestionByIdSource(questionId);
console.log(indexOfQuestionSource);

//SET DATA BY QUESTION ID SOURCE
 // const initialData = props.quizRedux.initialDataForQuizType4[indexOfQuestion];
//console.log(initialData);

  const initialData4Version = props.quizRedux.initialDataForQuizType4[indexOfQuestion];
  const initialData4VersionSource = props.quizRedux.initialDataForQuizType4Source[indexOfQuestionSource];
  //const initialData = stateData;
  const {dispatch} = props;
console.log(initialData4Version);
console.log(initialData4VersionSource);

//ON CLICK ANSWER DND3

const onAnswerDND3 = () => {
  console.log('Start check result DND3');
 
  // SET STATUS IF QUEST COMPLETE
  //setStateAnswerStatus3Version(true);

  const arr1 = initialData4Version.columns['column-1'].taskIds;
  const arr2 = initialData4Version.columns['column-1'].taskRightIds;
  //const n1 = arr1.toString();
  console.log(initialData4Version.columns['column-1'].taskIds);
  console.log(initialData4Version.columns['column-1'].taskRightIds);
  const result = arr1.toString() === arr2.toString();

    // SET RESULT INDICATOR
  let resultIndicator;
  if (result) {
   //console.log(result);
    console.log('ARRAY EQUEL!!!');
    resultIndicator = '100';
  } else {
    console.log('ARRAY not EQUEL!!!');
    resultIndicator = '0';
  }

    // SET RESULT
  props.onAnswerSelected(999, resultIndicator);

}


// ON DRAG END LIKE 1 VERSION  FOR SORTING BY SOURCE VOLUES
const onDragEnd3Version = (result) => {
  const {destination, source, draggableId} = result;
  if (!destination) {
    return;
  }
  if (
    destination.droppableId === source.droppableId &&
    destination.index === source.index
  ) {
    return;
  }
  const column = initialData4Version.columns[source.droppableId];
  const newTasksId = Array.from(column.taskIds);
  newTasksId.splice(source.index, 1);
  newTasksId.splice(destination.index, 0 , draggableId);

  const newColumn = {
    ...column,
    taskIds: newTasksId,
  }

  const  newState = {
    ...initialData4Version,
    columns: {
      ...initialData4Version.columns,
      [newColumn.id]: newColumn
    },
  }
  console.log('new state before dispatch');
  
  dispatch(setNewStateForQuizType4(newState));







}

//NEXT QUESTION
const nextQuestion = () => {
            let style;
          
           if (props.quizRedux.selectedItem != null) {
                style = ''
            } else {
                style = 'disabled'
            }
 
           
            return (
                <div>
                    <button onClick={props.nextQuestion.bind(this, props.quizRedux.dataQuizQuestions.length !== (props.quizRedux.counterQuestion +1) ? props.quizRedux.dataQuizQuestions[props.quizRedux.counterQuestion+1].sort_quest : null)}  disabled={style}>Следующий</button>
                </div>
            )

    }

// RENDER COLUMN 3 VERSION
const renderDND3 =() => {
  console.log('start render DND');
  
  return (
    <div>
      <div className="Quiz-header">
        
             <QuestionCount 
                 counter={props.quizRedux.questionId} 
                 total={props.quizRedux.questionLength}  
       />
                            
          </div>
      <p className='text-main'>{initialData4Version.text}</p>

      <div className='container-row'>      
        {
                initialData4VersionSource.columnOrder.map(columnId => {
                  const column = initialData4VersionSource.columns[columnId];
                  console.log('START GET SOURCE');
                  console.log(column);
                  const tasks = column.taskIds.map(taskId => initialData4VersionSource.tasks[taskId]);
                  //const title = 'sort by need';
                  return <ColumnSource key={column.id} column={column} tasks={tasks} 
                  
                  />
                } )
        }

        <DragDropContext onDragEnd={onDragEnd3Version}>
          <div className="container">
          
            {
                initialData4Version.columnOrder.map(columnId => {
                  const column = initialData4Version.columns[columnId];
                  console.log(column);
                  const tasks = column.taskIds.map(taskId => initialData4Version.tasks[taskId]);
                  //const title = 'sort by need';
                  return <Column key={column.id} column={column} tasks={tasks} 
                  styleAnswer={props.styleAnswer}
                  isSelected={props.isSelected}
                  />
                } )
            
            }
          </div>
  
        </DragDropContext>
      </div>
      <button onClick={onAnswerDND3} disabled={props.isSelected}> Ответить</button>
    </div> 
   
)
  
};




    return (
      <div className="Quiz">
     

        {renderDND3()}
        {nextQuestion()}   
          
  
      </div>
    );




  }
  
  export default QuizType4;